Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentRetweetView extends Backbone.View
  tagName: 'span'
  className: 'sc-retweet'

  initialize: (options = {}) ->
    @contentEnhancer = options.contentEnhancer
    @originalAuthor = options.originalAuthor

  render: ->
    @$el.html "RT #{@_enhancedOriginalAuthor()}:"
    this

  _enhancedOriginalAuthor: ->
    @contentEnhancer("@#{@originalAuthor}").getContent(evidenceField: null)
